import { List, Tag } from "antd";
import {
  UserAddOutlined,
  DollarOutlined,
  StopOutlined,
  MessageOutlined,
  CloseCircleOutlined,
  FormOutlined,
} from "@ant-design/icons";

function LatestActivities({ activities }) {
  const getIcon = (type) => {
    switch (type) {
      case "new_user":
        return <UserAddOutlined style={{ color: "#52c41a" }} />;
      case "payment":
        return <DollarOutlined style={{ color: "#1890ff" }} />;
      case "cancelled":
        return <StopOutlined style={{ color: "#f5222d" }} />;
      case "ticket":
        return <FormOutlined style={{ color: "#fa8c16" }} />;
      default:
        return null;
    }
  };

  const getDescription = (item) => {
    switch (item.type) {
      case "new_user":
        return `Neuer Nutzer registriert am ${item.date}`;
      case "payment":
        return `Zahlung von ${item.amount} am ${item.date}`;
      case "cancelled":
        return `Abo gekündigt am ${item.date}`;
      case "ticket":
        return `Support-Ticket erstellt: ${item.subject}`;
      default:
        return "";
    }
  };

  return (
    <List
      itemLayout="horizontal"
      dataSource={activities}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            avatar={getIcon(item.type)}
            title={item.user}
            description={getDescription(item)}
          />
          <Tag
            color={
              item.type === "new_user"
                ? "green"
                : item.type === "payment"
                ? "blue"
                : item.type === "cancelled"
                ? "red"
                : "orange"
            }
          >
            {item.type}
          </Tag>
        </List.Item>
      )}
    />
  );
}

export default LatestActivities;
